import { SERVICE_LOG } from '@/constants'
import api from '@/utils/api';

// eslint-disable-next-line import/prefer-default-export
export async function loadServiceAppCodes() {
  const [behaviors, objectives, progresses, implementations, assistTypes] = await Promise.all([
    api.get(SERVICE_LOG.LOOKUP_URLS.BEHAVIOR),
    api.get(SERVICE_LOG.LOOKUP_URLS.OBJECTIVE),
    api.get(SERVICE_LOG.LOOKUP_URLS.PROGRESS),
    api.get(SERVICE_LOG.LOOKUP_URLS.IMPLEMENTATION),
    api.get(SERVICE_LOG.LOOKUP_URLS.ASSIST_TYPE)
  ]);
  return [
    behaviors.data.data,
    objectives.data.data,
    progresses.data.data,
    implementations.data.data,
    assistTypes.data.data
  ];
}

export function filterDisabledOptions(optionsArray, currVal) {
  const filteredOptions = [];
  optionsArray.forEach((option) => {
    if (!option.disabledFlag || option.value === currVal) {
      filteredOptions.push(option);
    }
  });
  return filteredOptions;
}




// WEBPACK FOOTER //
// ./src/utils/service-log-utils.js